var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolaroidPhoto(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "polaroid-photo_svg__nc-icon-wrapper"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M42 47H6a2 2 0 01-2-2V3a2 2 0 012-2h36a2 2 0 012 2v42a2 2 0 01-2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M40 38H8a1 1 0 01-1-1V5a1 1 0 011-1h32a1 1 0 011 1v32a1 1 0 01-1 1z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EFD358",
    cx: 22,
    cy: 13,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4DA34D",
    d: "M10.3 30.375l5.92-7.399a1 1 0 011.56 0l5.92 7.4A1 1 0 0122.92 32H11.08a1 1 0 01-.78-1.625z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#72C472",
    d: "M19 32l9.186-12.86a1 1 0 011.628 0l8.057 11.279A1 1 0 0137.057 32H19z"
  }))));
}
export default SvgPolaroidPhoto;